<template>
  <li class="result-item h-auto">
    <a
      class="flex w-full flex-1 items-center gap-4 px-6 py-2 text-base transition-colors duration-100 ease-in-out hover:bg-black-10"
      :href="to"
      @click.prevent="handleClick(index, to, term)"
    >
      <NuxtImg
        v-if="imageUrl"
        class="aspect-[3/4] h-16 w-auto bg-gray-40 lg:h-9"
        sizes="xs:96px, lg:27px"
        :src="imageUrl"
      ></NuxtImg>
      <WordHighlighter :query="term" highlight-class="font-bold bg-transparent">
        <slot />
      </WordHighlighter>
    </a>
  </li>
</template>

<script lang="ts">
import WordHighlighter from 'vue-word-highlighter'
import useTrackingEvents from '~/composables/tracking/useTrackingEvents'

export default defineComponent({
  name: 'SearchResultItem',
  components: {
    WordHighlighter,
  },
  props: {
    term: {
      type: String as PropType<string>,
      default: '',
    },
    to: {
      type: [Object, String] as PropType<string>,
      required: true,
    },
    imageUrl: {
      type: String as PropType<string>,
      default: '',
    },
    index: { type: Number as PropType<number>, default: () => {} },
    section: { type: String as PropType<string>, default: () => {} },
  },
  emits: ['click:result'],

  setup(props, { emit }) {
    const { trackSearchSuggestions } = useTrackingEvents()
    const router = useRouter()
    const handleClick = (
      position: number,
      suggestion: string,
      searchTerm: string,
    ) => {
      trackSearchSuggestions({
        searchTerm,
        suggestion,
        position: position + 1,
        section: props.section,
      })
      emit('click:result')
      router.push(props.to as string)
    }
    return {
      handleClick,
    }
  },
})
</script>

<style scoped>
.result-item mark {
  background: transparent !important;
  font-weight: bold !important;
}
</style>
